export enum EvaluationReviewPeriod {
  ONE_MONTH = 'ONE_MONTH',
  THREE_MONTH = 'THREE_MONTH',
  SIX_MONTH = 'SIX_MONTH',
  ONE_YEAR = 'ONE_YEAR'
}
